/** Werving — kleine gedeelde bouwstenen met de kleurtaal van de module (fasechip, initialen-avatar). */
import React from 'react';
import { Box } from '@mui/material';
import { avatarKleur, faseKleur, initialen } from './wervingLogica';

/** Fasechip: zachte achtergrond + donkere tekst; `klein` = alleen een gekleurde stip met tekst (lijsten). */
export function FaseChip({ fase, label, klein = false }) {
  const kl = faseKleur(fase);
  if (klein) {
    return (
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.6, fontSize: 11.5, color: kl.tekst }}>
        <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: kl.stip, flexShrink: 0 }} />{label}
      </Box>
    );
  }
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.6, px: 1, py: 0.25, borderRadius: 10,
      bgcolor: kl.bg, color: kl.tekst, fontSize: 12, fontWeight: 600, lineHeight: 1.5, whiteSpace: 'nowrap' }}>
      <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: kl.stip }} />{label}
    </Box>
  );
}

/** Initialen in een vaste zachte kleur per naam. */
export function Avatar({ naam, maat = 28 }) {
  const kl = avatarKleur(naam);
  return (
    <Box aria-hidden sx={{ width: maat, height: maat, borderRadius: '50%', bgcolor: kl.bg, color: kl.tekst, flexShrink: 0,
      display: 'grid', placeItems: 'center', fontSize: Math.round(maat * 0.4), fontWeight: 700, letterSpacing: '0.02em' }}>
      {initialen(naam)}
    </Box>
  );
}
